/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { AnyAction, combineReducers, configureStore, Reducer } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import thunk from "redux-thunk";
import { apiSlice } from "./api/apiSlice";
import { AuthReducer } from "./api/auth/reducer";
import { DeviceFilterReducer } from "./filters/Nodes/reducer";
import { InventoryFilterReducer } from "./filters/Inventory/reducer";
import { EventFilterReducer } from "./filters/events/EventFilterReducer";
import { searchReducer } from "./search/reducer";
import { HelperReducers } from "./helpers/helperReducers";
import { AdminReducers } from "./api/admin/reducers";
import { AuditFilterReducer } from "./filters/audit/reducers";
import { DeviceConfigReducers } from "./api/deviceConfig/reducers";
import { DeviceReducers } from "./api/devices/reducers";
import { tasksReducer } from "./api/tasks/reducer";
import { MigrationReducers } from "./api/migration/reducers";
import { reportFilterReducer } from "./filters/Reports/reducers";
import { NotificationDeviceFilterReducer } from "./filters/devices/NotificationDeviceFilterReducer";
import { LabelDeviceFilterReducer } from "./filters/devices/Label/LabelDeviceFilterReducer";
import { TopOffenderFilterReducer } from "./filters/topoffender/reducer";
import { ThresholdCrossingDeviceFilterReducer } from "./filters/profiles/ThresholdCrossingDeviceFilterReducers";
import { DasInventoryFilterReducer } from "./filters/dasInventory/reducer";
import { AlarmFilterReducer } from "./filters/alarms/reducers";
import { TaskFilterReducer } from "./filters/tasks/reducers";
//  This is a nice way to auto-console.log any changes in Redux state.
//  If this gets too chatty, we can always turn it off or write our own
//  debug logging class.
const middleware: any = [thunk];
if (process.env.NODE_ENV !== "production") {
  // middleware.push(createLogger());
}

export const AppReducer: Reducer = combineReducers({
  authentication: AuthReducer,
  admin: AdminReducers,
  filter: DeviceFilterReducer,
  inventoryFilter: InventoryFilterReducer,
  eventfilter: EventFilterReducer,
  alarmfilter: AlarmFilterReducer,
  taskfilter: TaskFilterReducer,
  helpers: HelperReducers,
  [apiSlice.reducerPath]: apiSlice.reducer,
  search: searchReducer,
  auditFilter: AuditFilterReducer,
  deviceConfig: DeviceConfigReducers,
  device: DeviceReducers,
  tasks: tasksReducer,
  migration: MigrationReducers,
  reportFilter: reportFilterReducer,
  notificationDeviceFilter: NotificationDeviceFilterReducer,
  labelDeviceFilter: LabelDeviceFilterReducer,
  topOffenderFilters: TopOffenderFilterReducer,
  thresholdCrossingDeviceFilter: ThresholdCrossingDeviceFilterReducer,
  dasInventoryFilter: DasInventoryFilterReducer,
});

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === "auth/logout") {
    // Reset store while logout
    state = {};
  }
  return AppReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middleware).concat(apiSlice.middleware),
  // .concat(deviceApiSlice.middleware),
  devTools: true,
});

setupListeners(store.dispatch);

export type StoreDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof AppReducer>;
